import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { NkChanges } from '@nk/utils-lib';

@Component({
  selector: 'nk-caret-expander',
  imports: [],
  templateUrl: './caret-expander.component.html',
  styleUrls: ['./caret-expander.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaretExpanderComponent implements OnChanges {
  @Input() public isExpanded = false;
  @Input() public topOffest = 5;
  @HostBinding('class.d-inline-flex') public inlineFlex = true;
  @HostBinding('class.justify-content-center') public justifyContentCenter = true;
  @HostBinding('class.align-items-center') public alignItemsCenter = true;
  @HostBinding('class.rounded') public rounded = true;
  @HostBinding('class.bg-secondary') public bgSecondary = true;
  @HostBinding('class.text-primary') public textPrimary = true;
  @HostBinding('class.text-center') public textCenter = true;
  @HostBinding('style.width.px') public width = 22;
  @HostBinding('style.height.px') public height = 22;
  @HostBinding('style.cursor') public cursor = 'pointer';
  @HostBinding('style.top') public top = `${this.topOffest}%`;
  @HostBinding('style.position') public position = 'relative';

  public ngOnChanges(changes: NkChanges<CaretExpanderComponent>): void {
    if (changes.topOffest) {
      this.top = `${this.topOffest}%`;
    }
  }
}
